<template>
  <div class="pag-wrap exhibitor">
    <div class="bread-crumbs">
      <a
        href="//www.ciftis.org"
        clstag="appH5|keycount|exhibitorList|to-HomePage"
        >{{ $t('首页') }}</a
      ><i></i
      ><router-link
        tag="a"
        to="list"
        clstag="appH5|keycount|exhibitorList|to-exhibitorList"
        >{{ $t('展商名录') }}</router-link
      ><i></i><span>{{ $t('展商名录详情') }}</span>
    </div>
    <div class="detail-box">
      <div class="title">
        <a href="javascript:;" v-if="boothLogo">
          <span class="boothLogo"><img :src="boothLogo"/></span>
        </a>
        <div class="info">
          <h3>{{ title }}</h3>
          <dl :class="locale == 'en-US' ? 'isEnglish' : ''">
            <dd>
              <span>{{ $t('所属行业') }}：</span
              >{{
                locale == 'en-US'
                  ? (industryClass[accountIndustry] &&
                      industryClass[accountIndustry].enName) ||
                    ''
                  : (industryClass[accountIndustry] &&
                      industryClass[accountIndustry].name) ||
                    ''
              }}
            </dd>
            <dd>
              <span>{{ $t('注册地') }}：</span>{{ registration }}
            </dd>
            <dd>
              <span>{{ $t('单位性质') }}：</span
              >{{ $t(governmentMap[isgovernment || 2]) }}
              <el-popover
                :width="locale == 'en-US' ? 560 : 320"
                placement="right"
                v-if="!industryClass || isgovernment == 2"
                :content="
                  $t(
                    '其他机构包括：各个商业组织机构、商业协会、行业协会、院校、医院等社会组织'
                  )
                "
                trigger="hover"
              >
                <i slot="reference" class="icon-help">?</i>
              </el-popover>
            </dd>
            <dd>
              <span>{{ $t('邮箱') }}：</span>{{ accountContactEmail }}
            </dd>
          </dl>
        </div>
        <div class="btn-box">
          <el-button
            type="primary"
            class="entry-btn"
            v-if="boothLogo"
            @click="jumpBooth()"
          >
            {{ $t('进入展台') }}<i></i>
          </el-button>
          <el-button
            type="primary"
            class="entry-btn"
            @click="openKf()"
            v-if="chatShow"
          >
            {{ $t('立即洽谈') }}<i></i>
          </el-button>
        </div>
      </div>
      <div class="content-box" v-html="enterpriseinfo"></div>
    </div>
    <kf ref="kf" :enterpriseId="enterpriseId"></kf>
    <chat-forbid ref="chatForbid"></chat-forbid>
  </div>
</template>

<script>
import {
  getIndustryClass,
  getExhibitorDetail,
  getShopList
} from '@/api/exhibition'
import { getAccountUserInfo, getAccount } from '@/api/registry-api'
import { getLang } from '@/utils'
import { REGISTED_ZONE, REGISTED_ORIGIN } from '@/utils/registRegion'
import Kf from '@/views/exhibitorList/kf'
import chatForbid from '@/views/exhibitorList/chatForbid'
export default {
  components: { Kf, chatForbid },
  data() {
    return {
      accountName: this.$route.query.accountName,
      enterpriseId: this.$route.query.enterpriseId,
      chat: this.$route.query.chat,
      title: '',
      enterpriseinfo: '',
      accountIndustry: '',
      registration: '',
      isgovernment: '',
      accountContactPhone: '',
      accountContactEmail: '',
      locale: getLang() || 'zh-CN',
      boothLogo: '',
      boothUrl: '#',
      isTest: '',
      hostname: '',
      governmentMap: {
        0: '国际企业',
        1: '国内企业',
        2: '其他机构'
      },
      industryClass: {},
      registZone: {},
      registOrigin: {},
      chatJudgeData: {
        accountType: '',
        accountStatus: '',
        userDuty: ''
      },
      chatShow: false
    }
  },
  created() {
    let _hostName = location.hostname.split('.')
    this.isTest =
      _hostName[0].indexOf('-test') >= 0 || location.port !== '' ? true : false
    this.hostname =
      _hostName[1] +
      '.' +
      _hostName[2] +
      (_hostName[3] ? '.' + _hostName[3] : '')

    REGISTED_ZONE.forEach(_zone => {
      this.registZone[_zone.value] = _zone.label
    })
    REGISTED_ORIGIN.forEach(_region => {
      this.registOrigin[_region.value] = _region.label
    })
  },
  async mounted() {
    await this.getIndustryClassAction()
    await this.getAccountDetail()
    await this.get2dShopInfo()
    await this.getAccountUserInfoEvt()
    if (
      [
        'EXHIBITOR1',
        'EXHIBITOR2',
        'BUYER',
        'ORGANIZER',
        'CONTRACTOR1',
        'CONTRACTOR2',
        'ORGANIZE_OFFICE',
        'BOOTH_SALES'
      ].includes(this.chatJudgeData.accountType) &&
      this.chatJudgeData.accountStatus === 'APPROVED' &&
      ['BUSINESS_REPRESENTATIVE', 'CUSTOMER_SERVICE'].includes(
        this.chatJudgeData.userDuty
      )
    ) {
      this.chatShow = true
      this.chat === 'open' ? this.$refs.kf.open() : null
    } else {
      this.chatShow = false
      this.chat === 'open' ? this.$refs.chatForbid.open() : null
    }
    document.getElementById(
      'meta-keywords'
    ).content = `中国国际服务贸易交易会,服贸会,峰会,专题论坛,国际展会,服务贸易,京交会,交易会,展商名录,${this.title}`
  },
  methods: {
    errorHandle() {
      // if (_err.status == 401 ||_err.status == 429) return
      // this.$message({
      //   type: 'error',
      //   message: _err.message || getTranslation('请求失败，请稍后重试~')
      // })
    },
    async getIndustryClassAction() {
      this.isIndustryLoading = true
      try {
        let _data = await getIndustryClass({
          categoryType: 'INDUSTRY'
        })
        this.isIndustryLoading = false
        if (_data) {
          let _industryArr = _data.data.records
          _industryArr.forEach(_industry => {
            this.industryClass[_industry.categoryId] = {
              name: _industry.categoryName,
              enName: _industry.categoryEnglishName
            }
          })
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },
    async getAccountDetail() {
      if (!this.enterpriseId) return
      try {
        let _data = await getExhibitorDetail(this.enterpriseId)
        if (_data.data) {
          this.title =
            this.locale == 'en-US'
              ? _data.data.enterpriseEnglishName || _data.data.enterpriseName
              : _data.data.enterpriseName
          this.enterpriseinfo =
            this.locale == 'en-US'
              ? _data.data.englishIntroduction || 'No description'
              : _data.data.introduction || '暂无描述'
          this.accountContactEmail = _data.data.contactEmail
          this.accountIndustry = _data.data.category
          this.registration = _data.data.addressDetail
          this.isgovernment = _data.data.isgovernment
          // this.accountContactPhone = _data.data.accountContactPhone
          document.title = this.title
          this.accountName = this.title
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },

    async get2dShopInfo() {
      try {
        let _data = await getShopList({
          applyCustIdList: this.enterpriseId
        })
        if (_data.statusCode == 200 && _data.obj && _data.obj.length > 0) {
          this.boothLogo = _data.obj[0].filePath
          this.boothUrl = `//2d${this.isTest ? '-test' : ''}.${
            this.hostname
          }/view/shopmgr/shopdetail?applyCustId=${this.enterpriseId}&applyId=${
            _data.obj[0].applyId
          }`
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },
    async getAccountUserInfoEvt() {
      let userData = await getAccountUserInfo()
      let accountData = await getAccount()
      this.chatJudgeData.userDuty = userData.data.userDuty
      this.chatJudgeData.accountType = accountData.data.accountType
      this.chatJudgeData.accountStatus = accountData.data.accountStatus
    },
    jumpBooth() {
      window.open(this.boothUrl)
    },
    openKf() {
      this.$refs.kf.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-box {
  padding: 30px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 140px;
    height: auto;
    margin: 0 0 38px;
    padding: 0 24px;
    background: url('../../assets/img/bg-exhibitor.png') center no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    a {
      flex-shrink: 0;
      position: static;
      width: 82px;
      height: 82px;
      margin: 0 40px 0 0;
      padding: 0px;
      border-radius: 41px;
      background: #ffd461;
      transform: translateY(0);

      .boothLogo {
        left: 7px;
        top: 7px;
        width: 68px;
        height: 68px;
        margin: 0;
        background: transparent;
        border: 6px solid rgba(255, 255, 255, 0.5);
        box-shadow: none;
        transform: none;

        &::before {
          content: '';
          position: absolute;
          z-index: 0;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: #fff;
          border-radius: 100%;
        }
      }
      .boothLink {
        margin-top: 41px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
      }
      i {
        height: 82px;
        margin: 0 0 0 20px;

        &::after {
          border-color: #fff;
        }
      }

      &:hover {
        .boothLink {
          color: #fff;
        }
        i::after {
          border-color: #fff;
        }
      }
    }

    .info {
      width: 100%;
    }

    h3 {
      margin: 30px 0 20px;
      color: #0a1b43;
      font-size: 28px;
      line-height: 40px;
      transform: translateY(0);
    }

    .btn-box {
      display: flex;
      flex-shrink: 0;
      position: static;
      margin: 0 0 0 40px;
    }
    dl {
      width: 80%;
      margin: 0 0 16px;
      overflow: hidden;

      &.isEnglish {
        width: 96%;
      }

      dt {
        float: left;
        margin: 0 20px 20px 0;
        color: #333;
        font-size: 16px;
        line-height: 20px;
      }
      dd {
        float: left;
        min-width: 35%;
        margin: 0 0 6px;
        padding: 0 40px 0 0;
        color: #333;
        font-size: 16px;
        white-space: nowrap;
        line-height: 20px;

        span {
          color: #999;
        }
        .icon-help {
          position: relative;
          display: inline-block;
          width: 16px;
          height: 20px;
          margin: 0 0 0 12px;
          text-align: center;

          &::after {
            content: '?';
            position: absolute;
            z-index: 0;
            left: 0;
            right: 0;
            top: 2px;
            width: 16px;
            height: 16px;
            background: #fe8c01;
            border-radius: 8px;
            color: #fff;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
  }
  .content-box {
    border-bottom: none;
    line-height: 32px;
  }
}
</style>
